import { apiClient } from "./client";

export interface DashboardPayment {
  id: string;
  tenantId: string;
  planId: string;
  provider: string;
  providerPaymentId: string;
  amount: number;
  currency: string;
  status: string;
  checkoutUrl: string;
  durationDays: number;
  endDate: string | null;
  lastCheckedAt: string;
  webhookProcessed: boolean;
  createdAt: string;
  plan: { id: string; name: string };
  tenant: { id: string; name: string };
}

export interface DashboardStats {
  totalUsers: number;
  activeSubscriptions: number;
  paidActiveSubscriptions: number;
  totalRevenue: number;
  totalSessions: number;
  connectedSessions: number;
  totalMessages: number;
  openTickets: number;
  lastValidatedPayments: DashboardPayment[];
}

export const dashboardApi = {
  /**
   * Statistiques globales admin
   * GET /v1/admin/dashboard
   */
  getStats: () => apiClient.get<DashboardStats>("/admin/dashboard"),
};
